import { render, staticRenderFns } from "./StartProcedure.vue?vue&type=template&id=38a3000a"
import script from "./StartProcedure.vue?vue&type=script&lang=js"
export * from "./StartProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports